import { get } from "jquery";
import {
  GET_DASHBOARD_DATA_ORM,
  GET_PROJECT_FILTER_ORM,
  GET_RESPONSIBLE_FILTER_ORM,
  GET_ACCOUNTABLE_FILTER_ORM,
  GET_PROJECT_BD_OWNER_FILTER_ORM,
  GET_PROJECT_PROPOSAL_OWNER_FILTER_ORM,
  GET_LIAISON_PROCESS_DATA_ORM,
  GET_LIAISON_PROCESS_ORM,
  GET_LIAISON_PROCESS_ORM_EXPORT,
  GET_LIAISON_PROCESS_SUMMARY_ORM,
  GET_LIAISON_PROCESS_SUMMARY_ORM_EXPORT,
  GET_LIAISON_TASK_PLAN_ORM,
  GET_LIAISON_TASK_PLAN_ORM_EXPORT,
  GET_LIAISON_DOCUMENTATION_DATA_ORM,
  GET_LIAISON_DOCUMENTATION_SUMMARY_ORM,
  GET_LIAISON_DOCUMENTATION_SUMMARY_ORM_EXPORT,
  GET_LIAISON_DOCUMENTATION_ORM,
  GET_LEGAL_DATA_ORM,
  GET_LEGAL_SUMMARY_ORM,
  GET_LEGAL1_DATA_ORM,
  GET_LEGAL1_SUMMARY_ORM,
  GET_LEGAL_ORM,
  GET_LEGAL1_ORM,
  GET_COURT_CASE_DATA_ORM,
  GET_COURT_CASE_SUMMARY_ORM,
  GET_COURT_CASE_ORM,
  GET_PROJECT_PROGRESS_DASHBOARD_ORM,
  GET_BUSINESS_DEVELOPMENT_DATA_ORM,
  GET_SALES_DATA_ORM,
  GET_SALES_SUMMARY_ORM,
  GET_SALES_ORM,
  GET_CP_SALES_DATA_ORM,
  GET_CP_SALES_SUMMARY_ORM,
  GET_CP_SALES_ORM,
  GET_PRE_SALES_DATA_ORM,
  GET_PRE_SALES_SUMMARY_ORM,
  GET_PRE_SALES_ORM,
  GET_CANCELLATION_SALES_DATA_ORM,
  GET_CANCELLATION_SALES_SUMMARY_ORM,
  GET_CANCELLATION_SALES_ORM,
  GET_COLLECTION_DATA_ORM,
  GET_COLLECTION_SUMMARY_ORM,
  GET_COLLECTION_ORM,
  GET_AGREEMENT_DATA_ORM,
  GET_AGREEMENT_SUMMARY_ORM,
  GET_AGREEMENT_SUMMARY_ORM_EXPORT,
  GET_AGREEMENT_ORM,
  GET_AGREEMENT_ORM_CARD,
  GET_REGISTRATION_DATA_ORM,
  GET_REGISTRATION_SUMMARY_ORM,
  GET_REGISTRATION_SUMMARY_ORM_EXPORT,
  GET_REGISTRATION_ORM,
  GET_CUSTOMER_DATA_ORM,
  GET_CUSTOMER_SUMMARY_ORM,
  GET_CUSTOMER_ORM,
  GET_MARKETING_DATA_ORM,
  GET_MARKETING_SUMMARY_ORM,
  GET_MARKETING_ORM,
  GET_MARKETING_FUNNEL_DATA_ORM,
  GET_MARKETING_FUNNEL_SUMMARY_ORM,
  GET_MARKETING_FUNNEL_ORM,
  GET_SURVEY_DATA_ORM,
  GET_BUSINESS_DEVELOPMENT_DATA_ORM1,
  GET_PROJECT_PLAN_DELAY_REASON,
  GET_PROJECT_PLAN_CHANGE_HISTORY,
  GET_SURVEY_SUMMARY_ORM,
  GET_SURVEY_ORM,
  GET_PROJECT_HANDOVER_DATA_ORM,
  GET_PROJECT_HANDOVER_SUMMARY_ORM,
  GET_PROJECT_HANDOVER_ORM,
  GET_ACTION_FOR_BD,
  GET_ACTION_FOR_LIAISON_PROCESS,
  GET_ACTION_FOR_LIAISON_DOCUMENTATION,
  GET_ACTION_FOR_SURVEY,
  GET_ACTION_FOR_BOUNDARY_DISPUTE,
  GET_ACTION_FOR_COURT_CASE,
  GET_ACTION_FOR_LEGAL_TASK,
  GET_ACTION_FOR_MARKETING,
  GET_ACTION_FOR_PRE_SALES,
  GET_ACTION_FOR_SALES,
  GET_ACTION_FOR_CP_SALES,
  GET_ACTION_FOR_CANCELLATION,
  GET_ACTION_FOR_COLLECTION,
  GET_ACTION_FOR_AGREEMENT,
  GET_ACTION_FOR_REGISTRATION,
  GET_ACTION_FOR_CUSTOMER_TICKET,
  GET_ACTION_FOR_PROJECT_HANDOVER,
  GET_ACTION_FOR_PROCUREMENT_PLAN,
  GET_ACTION_FOR_STOCK_SUMMARY,
  GET_PROCUREMENT_DATA_ORM,
  GET_PROCUREMENT_SUMMARY_ORM,
  GET_PROCUREMENT_ORM,
  GET_STORE_DATA_ORM,
  GET_STORE_SUMMARY_ORM,
  GET_STORE_ORM,
  GET_ACTION_FOR_CIVIL_INITIATION,
  GET_ACTION_FOR_CIVIL_PROCESS,
  GET_ACTION_FOR_HR,
  GET_ACTION_FOR_COMPLIANCE,
  GET_HR_ORM,
  GET_ACTION_FOR_APF,
  GET_ACTION_FOR_PROJECT_LOAN,
  GET_CIVIL_DATA_ORM,
  GET_CIVIL_INITIATION_DATA_ORM,
  GET_APF_TASK_PLAN_REPORT_ORM,
  GET_PROJECT_LOAN_SUMMARY_ORM,
  GET_PROCURMENT_PLAN_DATA_ORM,
  GET_PROJECT_PROGRESS_VIDEO,
  GET_AGREEMENT_ORM_EXPORT,
  GET_SURVEY_SKETCH_DASHBOARD,
  GET_REGISTRATION_ORM_EXPORT,
  GET_PROCURMENT_PLAN_ORM,
  GET_ACTION_FOR_PROCUREMENT_OUTSTANDING,
  GET_PROCURMENT_PLAN_SUMMARY_ORM,
  // Inventory Site
  GET_SITE_INVENTORY_DATA_ORM,
  GET_SITE_INVENTORY_ORM,
  GET_ACTION_FOR_SITE_INVENTORY,
  // Inventory Land
  GET_PROJECT_LAND_BANK_DATA_ORM,
  GET_PROJECT_LAND_BANK_DATA_ORM1,
  GET_PROJECT_LAND_BANK_ORM,
  GET_ACTION_FOR_LAND_BANK_ORM,
  GET_APF_TASK_PLAN_QUERY_ORM,
  GET_APF_TASK_PLAN_REPORT_ORM_EXPORT,
  GET_CIVIL_PROJECT_PROGRESS_DATA_ORM,
  GET_CIVIL_PROJECT_BUDGET_DATA_ORM,
  GET_SITE_INVENTORY_ORM_EXPORT,
  GET_PROJECT_LAND_BANK_ORM_EXPORT,
  GET_APF_TASK_PLAN_REPORT_PANEL_ORM,
  GET_PROJECT_LOAN_DATA_ORM,
  GET_ACTION_FOR_COLLECTION_PROJECTION,
  GET_COLLECTION_PROJECTION_DATA_ORM,
  GET_COLLECTION_OUTSTANDING,
  GET_COLLECTION_PROJECTION_SUMMARY_ORM,
  GET_COLLECTION_PROJECTION_ORM,
  GET_ACTION_FOR_BUDGET,
  GET_ACTION_FOR_SCHEDULE,
  GET_QC_ORM_EXPORT,
  GET_QC_ORM,
  GET_ACTION_FOR_QC,
  GET_QC_DATA_ORM,
  GET_QC_SUMMARY_ORM,
  GET_QC_INSPECTION_DATA_ORM,
  GET_QC_OBSERVATION_DATA_ORM,
  GET_QC_TRAINING_DATA_ORM,
  GET_QC_WALKTHROUGH_DATA_ORM,
  GET_QC_INSPECTION_ORM,
  GET_QC_OBSERVATION_ORM,
  GET_QC_TRAINING_ORM,
  GET_QC_WALKTHROUGH_ORM,
  GET_APF_TASK_PLAN_REPORT_BANK_ORM,
  GET_REGISTRATION_ORM_CARD,
  GET_COLLECTION_PROJECTION_ORM_EXPORT,
  GET_COLLECTION_ORM_EXPORT,
  GET_ACCOUNT_INVOICE_DATA,
  GET_ACCOUNT_INVOICE_SUMMARY,
  GET_ACCOUNT_INVOICE,
  GET_ACCOUNT_MARKETING_DATA,
  GET_ACCOUNT_MARKETING_SUMMARY,
  GET_ACCOUNT_MARKETING,
  //CRM User Dashboard
  GET_CRM_PAYMENT_OUTSTANDING_DATA
} from "./types";

const initialState = {
  getDashboardDataOrm: [],
  getProjectFilterORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getResponsibleFilterORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountableFilterORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectBdOwnerFilterORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectProposalOwnerFilterORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonProcessSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonProcessSummaryORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonProcessORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonProcessORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonTaskPlanORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonTaskPlanORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonProcessDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonDocumentationDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonDocumentationSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonDocumentationSummaryORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLiaisonDocumentationORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLegalDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLegalSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLegalORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLegal1DataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLegal1SummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLegal1ORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCourtCaseDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCourtCaseSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCourtCaseORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectProgressDashboardORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBusinessDevelopmentDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBusinessDevelopmentDataORM1: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectPlanDelayReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectPlanChangeHistory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCpSalesDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCpSalesSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCpSalesORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPreSalesORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCancellationSalesDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCancellationSalesSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCancellationSalesORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionOutstanding: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAgreementDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAgreementSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAgreementSummaryORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAgreementORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAgreementORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationSummaryORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationORMCard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingFunnelDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingFunnelSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingFunnelORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSurveyDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSurveySummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSurveyORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectHandOverDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectHandOverSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectHandOverORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForBD: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForLiaisonProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForLiaisonDocumentation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForSurvey: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForBoundaryDispute: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCourtCase: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForLegalTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Marketing Action ORM
  getActionForMarketing: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCPSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCancellation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCollection: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForAgreement: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForRegistration: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCustomerTicket: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForProjectHandover: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStoreDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStoreSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStoreORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForProcurementPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForStockSummary: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilInitiationDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectProgressVideo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCivilProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCivilInitiation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForBudget: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForSchedule: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForHr: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCompliance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForApf: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForProjectLoan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getApfTaskPlanReportORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectLoanSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentPlanDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSurveySketchDashboard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentPlanORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getActionForProcurementOutstanding: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProcurmentPlanSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Inventory Site
  getSiteInventoryDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteInventoryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForSiteInventory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectLandBankDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectLandBankDataORM1: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectLandBankORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForLandInventory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteInventoryORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectLandBankORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getApfTaskPlanQueryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getApfTaskPlanReportORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getApfTaskPlanReportPanelORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getApfTaskPlanReportBankORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectProgressDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBudgetDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectLoanDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionProjectionDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForCollectionProjection: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionProjectionSummaryOrm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionProjectionOrm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCollectionProjectionOrmExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcORMExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActionForQc: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcSummaryORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionDataOrm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationDataOrm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcTrainingDataOrm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWalkthroughDataORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcInspectionORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcObservationORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcTrainingORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getQcWalkthroughORM: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountInvoiceData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountInvoiceSummary: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountInvoice: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountMarketingData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountMarketingSummary: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountMarketing: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //CRM User Dashboard
  getCRMPaymentOutStandingData: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};

const Dashboard_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DASHBOARD_DATA_ORM:
      return Object.assign({}, state, { getDashboardDataOrm: payload });
    case GET_PROJECT_FILTER_ORM:
      return Object.assign({}, state, { getProjectFilterORM: payload });
    case GET_RESPONSIBLE_FILTER_ORM:
      return Object.assign({}, state, { getResponsibleFilterORM: payload });
    case GET_ACCOUNTABLE_FILTER_ORM:
      return Object.assign({}, state, { getAccountableFilterORM: payload });
    case GET_PROJECT_BD_OWNER_FILTER_ORM:
      return Object.assign({}, state, { getProjectBdOwnerFilterORM: payload });
    case GET_PROJECT_PROPOSAL_OWNER_FILTER_ORM:
      return Object.assign({}, state, {
        getProjectProposalOwnerFilterORM: payload
      });
    case GET_LIAISON_PROCESS_SUMMARY_ORM:
      return Object.assign({}, state, { getLiaisonProcessSummaryORM: payload });
    case GET_LIAISON_PROCESS_SUMMARY_ORM_EXPORT:
      return Object.assign({}, state, {
        getLiaisonProcessSummaryORMExport: payload
      });
    //Liaison Process
    case GET_LIAISON_PROCESS_ORM:
      return Object.assign({}, state, { getLiaisonProcessORM: payload });
    case GET_LIAISON_PROCESS_ORM_EXPORT:
      return Object.assign({}, state, { getLiaisonProcessORMExport: payload });
    case GET_LIAISON_TASK_PLAN_ORM:
      return Object.assign({}, state, { getLiaisonTaskPlanORM: payload });
    case GET_LIAISON_TASK_PLAN_ORM_EXPORT:
      return Object.assign({}, state, { getLiaisonTaskPlanORMExport: payload });
    case GET_LIAISON_PROCESS_DATA_ORM:
      return Object.assign({}, state, { getLiaisonProcessDataORM: payload });
    //Liaison Documentation
    case GET_LIAISON_DOCUMENTATION_DATA_ORM:
      return Object.assign({}, state, {
        getLiaisonDocumentationDataORM: payload
      });
    case GET_LIAISON_DOCUMENTATION_SUMMARY_ORM:
      return Object.assign({}, state, {
        getLiaisonDocumentationSummaryORM: payload
      });
    case GET_LIAISON_DOCUMENTATION_SUMMARY_ORM_EXPORT:
      return Object.assign({}, state, {
        getLiaisonDocumentationSummaryORMExport: payload
      });
    case GET_LIAISON_DOCUMENTATION_ORM:
      return Object.assign({}, state, { getLiaisonDocumentationORM: payload });
    case GET_LEGAL_DATA_ORM:
      return Object.assign({}, state, { getLegalDataORM: payload });
    case GET_LEGAL_SUMMARY_ORM:
      return Object.assign({}, state, { getLegalSummaryORM: payload });
    case GET_LEGAL_ORM:
      return Object.assign({}, state, { getLegalORM: payload });
    case GET_LEGAL1_DATA_ORM:
      return Object.assign({}, state, { getLegal1DataORM: payload });
    case GET_LEGAL1_SUMMARY_ORM:
      return Object.assign({}, state, { getLegal1SummaryORM: payload });
    case GET_LEGAL1_ORM:
      return Object.assign({}, state, { getLegal1ORM: payload });
    case GET_COURT_CASE_DATA_ORM:
      return Object.assign({}, state, { getCourtCaseDataORM: payload });
    case GET_COURT_CASE_SUMMARY_ORM:
      return Object.assign({}, state, { getCourtCaseSummaryORM: payload });
    case GET_COURT_CASE_ORM:
      return Object.assign({}, state, { getCourtCaseORM: payload });
    case GET_PROJECT_PROGRESS_DASHBOARD_ORM:
      return Object.assign({}, state, {
        getProjectProgressDashboardORM: payload
      });
    case GET_BUSINESS_DEVELOPMENT_DATA_ORM:
      return Object.assign({}, state, {
        getBusinessDevelopmentDataORM: payload
      });
    case GET_BUSINESS_DEVELOPMENT_DATA_ORM1:
      return Object.assign({}, state, {
        getBusinessDevelopmentDataORM1: payload
      });
    case GET_PROJECT_PLAN_DELAY_REASON:
      return Object.assign({}, state, {
        getProjectPlanDelayReason: payload
      });
    case GET_PROJECT_PLAN_CHANGE_HISTORY:
      return Object.assign({}, state, {
        getProjectPlanChangeHistory: payload
      });

    // ORM Sales
    case GET_SALES_DATA_ORM:
      return Object.assign({}, state, { getSalesDataORM: payload });
    case GET_SALES_SUMMARY_ORM:
      return Object.assign({}, state, { getSalesSummaryORM: payload });
    case GET_SALES_ORM:
      return Object.assign({}, state, { getSalesORM: payload });
    // CP Sales
    case GET_CP_SALES_DATA_ORM:
      return Object.assign({}, state, { getCpSalesDataORM: payload });
    case GET_CP_SALES_SUMMARY_ORM:
      return Object.assign({}, state, { getCpSalesSummaryORM: payload });
    case GET_CP_SALES_ORM:
      return Object.assign({}, state, { getCpSalesORM: payload });
    // Pre Sales
    case GET_PRE_SALES_DATA_ORM:
      return Object.assign({}, state, { getPreSalesDataORM: payload });
    case GET_PRE_SALES_SUMMARY_ORM:
      return Object.assign({}, state, { getPreSalesSummaryORM: payload });
    case GET_PRE_SALES_ORM:
      return Object.assign({}, state, { getPreSalesORM: payload });
    // Cancellation Sales
    case GET_CANCELLATION_SALES_DATA_ORM:
      return Object.assign({}, state, { getCancellationSalesDataORM: payload });
    case GET_CANCELLATION_SALES_SUMMARY_ORM:
      return Object.assign({}, state, {
        getCancellationSalesSummaryORM: payload
      });
    case GET_CANCELLATION_SALES_ORM:
      return Object.assign({}, state, { getCancellationSalesORM: payload });
    //Collection Sales
    case GET_COLLECTION_DATA_ORM:
      return Object.assign({}, state, { getCollectionDataORM: payload });
    case GET_COLLECTION_SUMMARY_ORM:
      return Object.assign({}, state, { getCollectionSummaryORM: payload });
    case GET_COLLECTION_ORM:
      return Object.assign({}, state, { getCollectionORM: payload });
    case GET_COLLECTION_ORM_EXPORT:
      return Object.assign({}, state, { getCollectionORMExport: payload });
    case GET_COLLECTION_OUTSTANDING:
      return Object.assign({}, state, { getCollectionOutstanding: payload });
    //Agreement Sales
    case GET_AGREEMENT_DATA_ORM:
      return Object.assign({}, state, { getAgreementDataORM: payload });
    case GET_AGREEMENT_SUMMARY_ORM:
      return Object.assign({}, state, { getAgreementSummaryORM: payload });
    case GET_AGREEMENT_SUMMARY_ORM_EXPORT:
      return Object.assign({}, state, {
        getAgreementSummaryORMExport: payload
      });
    case GET_AGREEMENT_ORM:
      return Object.assign({}, state, { getAgreementORM: payload });
    case GET_AGREEMENT_ORM_CARD:
      return Object.assign({}, state, { getAgreementORMCard: payload });
    case GET_AGREEMENT_ORM_EXPORT:
      return Object.assign({}, state, { getAgreementORMExport: payload });
    //Registration Sales
    case GET_REGISTRATION_DATA_ORM:
      return Object.assign({}, state, { getRegistrationDataORM: payload });
    case GET_REGISTRATION_SUMMARY_ORM:
      return Object.assign({}, state, { getRegistrationSummaryORM: payload });
    case GET_REGISTRATION_SUMMARY_ORM_EXPORT:
      return Object.assign({}, state, {
        getRegistrationSummaryORMExport: payload
      });
    case GET_REGISTRATION_ORM:
      return Object.assign({}, state, { getRegistrationORM: payload });
    case GET_REGISTRATION_ORM_CARD:
      return Object.assign({}, state, { getRegistrationORMCard: payload });
    case GET_REGISTRATION_ORM_EXPORT:
      return Object.assign({}, state, { getRegistrationORMExport: payload });
    //Customer
    case GET_CUSTOMER_DATA_ORM:
      return Object.assign({}, state, { getCustomerDataORM: payload });
    case GET_CUSTOMER_SUMMARY_ORM:
      return Object.assign({}, state, { getCustomerSummaryORM: payload });
    case GET_CUSTOMER_ORM:
      return Object.assign({}, state, { getCustomerORM: payload });
    //Marketting
    case GET_MARKETING_DATA_ORM:
      return Object.assign({}, state, { getMarketingDataORM: payload });
    case GET_MARKETING_SUMMARY_ORM:
      return Object.assign({}, state, { getMarketingSummaryORM: payload });
    case GET_MARKETING_ORM:
      return Object.assign({}, state, { getMarketingORM: payload });
    //Marketting Funnel
    case GET_MARKETING_FUNNEL_DATA_ORM:
      return Object.assign({}, state, { getMarketingFunnelDataORM: payload });
    case GET_MARKETING_FUNNEL_SUMMARY_ORM:
      return Object.assign({}, state, {
        getMarketingFunnelSummaryORM: payload
      });
    case GET_MARKETING_FUNNEL_ORM:
      return Object.assign({}, state, { getMarketingFunnelORM: payload });
    case GET_SURVEY_DATA_ORM:
      return Object.assign({}, state, { getSurveyDataORM: payload });
    case GET_SURVEY_SUMMARY_ORM:
      return Object.assign({}, state, { getSurveySummaryORM: payload });
    case GET_SURVEY_ORM:
      return Object.assign({}, state, { getSurveyORM: payload });
    case GET_PROJECT_HANDOVER_DATA_ORM:
      return Object.assign({}, state, { getProjectHandOverDataORM: payload });
    case GET_PROJECT_HANDOVER_SUMMARY_ORM:
      return Object.assign({}, state, {
        getProjectHandOverSummaryORM: payload
      });
    case GET_PROJECT_HANDOVER_ORM:
      return Object.assign({}, state, { getProjectHandOverORM: payload });
    //BD Action ORM
    case GET_ACTION_FOR_BD:
      return Object.assign({}, state, { getActionForBD: payload });
    case GET_ACTION_FOR_LIAISON_PROCESS:
      return Object.assign({}, state, { getActionForLiaisonProcess: payload });
    case GET_ACTION_FOR_LIAISON_DOCUMENTATION:
      return Object.assign({}, state, {
        getActionForLiaisonDocumentation: payload
      });
    case GET_ACTION_FOR_SURVEY:
      return Object.assign({}, state, { getActionForSurvey: payload });
    case GET_ACTION_FOR_BOUNDARY_DISPUTE:
      return Object.assign({}, state, { getActionForBoundaryDispute: payload });
    case GET_ACTION_FOR_COURT_CASE:
      return Object.assign({}, state, { getActionForCourtCase: payload });
    case GET_ACTION_FOR_LEGAL_TASK:
      return Object.assign({}, state, { getActionForLegalTask: payload });
    //Marketing Action ORM
    case GET_ACTION_FOR_MARKETING:
      return Object.assign({}, state, { getActionForMarketing: payload });
    case GET_ACTION_FOR_PRE_SALES:
      return Object.assign({}, state, { getActionForPreSales: payload });
    case GET_ACTION_FOR_SALES:
      return Object.assign({}, state, { getActionForSales: payload });
    case GET_ACTION_FOR_CP_SALES:
      return Object.assign({}, state, { getActionForCPSales: payload });
    case GET_ACTION_FOR_CANCELLATION:
      return Object.assign({}, state, { getActionForCancellation: payload });
    case GET_ACTION_FOR_COLLECTION:
      return Object.assign({}, state, { getActionForCollection: payload });
    case GET_ACTION_FOR_AGREEMENT:
      return Object.assign({}, state, { getActionForAgreement: payload });
    case GET_ACTION_FOR_REGISTRATION:
      return Object.assign({}, state, { getActionForRegistration: payload });
    case GET_ACTION_FOR_CUSTOMER_TICKET:
      return Object.assign({}, state, { getActionForCustomerTicket: payload });
    case GET_ACTION_FOR_PROJECT_HANDOVER:
      return Object.assign({}, state, { getActionForProjectHandover: payload });
    //Procurement
    case GET_PROCUREMENT_DATA_ORM:
      return Object.assign({}, state, { getProcurmentDataORM: payload });
    case GET_PROCUREMENT_SUMMARY_ORM:
      return Object.assign({}, state, { getProcurmentSummaryORM: payload });
    case GET_PROCUREMENT_ORM:
      return Object.assign({}, state, { getProcurmentORM: payload });
    case GET_STORE_DATA_ORM:
      return Object.assign({}, state, { getStoreDataORM: payload });
    case GET_STORE_SUMMARY_ORM:
      return Object.assign({}, state, { getStoreSummaryORM: payload });
    case GET_STORE_ORM:
      return Object.assign({}, state, { getStoreORM: payload });
    //Procurement Action
    case GET_ACTION_FOR_PROCUREMENT_PLAN:
      return Object.assign({}, state, { getActionForProcurementPlan: payload });
    case GET_ACTION_FOR_STOCK_SUMMARY:
      return Object.assign({}, state, { getActionForStockSummary: payload });
    //Civil
    case GET_CIVIL_DATA_ORM:
      return Object.assign({}, state, { getCivilDataORM: payload });
    case GET_CIVIL_INITIATION_DATA_ORM:
      return Object.assign({}, state, { getCivilInitiationDataORM: payload });
    case GET_PROJECT_PROGRESS_VIDEO:
      return Object.assign({}, state, { getProjectProgressVideo: payload });
    //Civil Action
    case GET_ACTION_FOR_CIVIL_PROCESS:
      return Object.assign({}, state, { getActionForCivilProcess: payload });
    case GET_ACTION_FOR_CIVIL_INITIATION:
      return Object.assign({}, state, { getActionForCivilInitiation: payload });
    case GET_ACTION_FOR_BUDGET:
      return Object.assign({}, state, { getActionForBudget: payload });
    case GET_ACTION_FOR_SCHEDULE:
      return Object.assign({}, state, { getActionForSchedule: payload });
    case GET_ACTION_FOR_HR:
      return Object.assign({}, state, { getActionForHr: payload });
    case GET_ACTION_FOR_COMPLIANCE:
      return Object.assign({}, state, { getActionForCompliance: payload });
    case GET_HR_ORM:
      return Object.assign({}, state, { getHrORM: payload });
    case GET_ACTION_FOR_APF:
      return Object.assign({}, state, { getActionForApf: payload });
    case GET_ACTION_FOR_PROJECT_LOAN:
      return Object.assign({}, state, { getActionForProjectLoan: payload });
    case GET_APF_TASK_PLAN_REPORT_ORM:
      return Object.assign({}, state, { getApfTaskPlanReportORM: payload });
    case GET_PROJECT_LOAN_SUMMARY_ORM:
      return Object.assign({}, state, { getProjectLoanSummaryORM: payload });
    case GET_PROCURMENT_PLAN_DATA_ORM:
      return Object.assign({}, state, { getProcurmentPlanDataORM: payload });
    case GET_SURVEY_SKETCH_DASHBOARD:
      return Object.assign({}, state, { getSurveySketchDashboard: payload });
    case GET_PROCURMENT_PLAN_ORM:
      return Object.assign({}, state, { getProcurmentPlanORM: payload });
    case GET_ACTION_FOR_PROCUREMENT_OUTSTANDING:
      return Object.assign({}, state, {
        getActionForProcurementOutstanding: payload
      });
    case GET_PROCURMENT_PLAN_SUMMARY_ORM:
      return Object.assign({}, state, { getProcurmentPlanSummaryORM: payload });
    // Inventory Site
    case GET_SITE_INVENTORY_DATA_ORM:
      return Object.assign({}, state, { getSiteInventoryDataORM: payload });
    case GET_SITE_INVENTORY_ORM:
      return Object.assign({}, state, { getSiteInventoryORM: payload });
    case GET_ACTION_FOR_SITE_INVENTORY:
      return Object.assign({}, state, { getActionForSiteInventory: payload });
    // Inventory Land
    case GET_PROJECT_LAND_BANK_DATA_ORM:
      return Object.assign({}, state, { getProjectLandBankDataORM: payload });
    case GET_PROJECT_LAND_BANK_DATA_ORM1:
      return Object.assign({}, state, { getProjectLandBankDataORM1: payload });
    case GET_PROJECT_LAND_BANK_ORM:
      return Object.assign({}, state, { getProjectLandBankORM: payload });
    case GET_ACTION_FOR_LAND_BANK_ORM:
      return Object.assign({}, state, { getActionForLandInventory: payload });
    case GET_SITE_INVENTORY_ORM_EXPORT:
      return Object.assign({}, state, { getSiteInventoryORMExport: payload });
    case GET_PROJECT_LAND_BANK_ORM_EXPORT:
      return Object.assign({}, state, { getProjectLandBankORMExport: payload });
    case GET_APF_TASK_PLAN_QUERY_ORM:
      return Object.assign({}, state, { getApfTaskPlanQueryORM: payload });
    case GET_APF_TASK_PLAN_REPORT_ORM_EXPORT:
      return Object.assign({}, state, {
        getApfTaskPlanReportORMExport: payload
      });
    case GET_CIVIL_PROJECT_PROGRESS_DATA_ORM:
      return Object.assign({}, state, {
        getCivilProjectProgressDataORM: payload
      });
    case GET_CIVIL_PROJECT_BUDGET_DATA_ORM:
      return Object.assign({}, state, {
        getCivilProjectBudgetDataORM: payload
      });
    case GET_APF_TASK_PLAN_REPORT_PANEL_ORM:
      return Object.assign({}, state, {
        getApfTaskPlanReportPanelORM: payload
      });
    case GET_APF_TASK_PLAN_REPORT_BANK_ORM:
      return Object.assign({}, state, {
        getApfTaskPlanReportBankORM: payload
      });
    case GET_PROJECT_LOAN_DATA_ORM:
      return Object.assign({}, state, {
        getProjectLoanDataORM: payload
      });
    case GET_COLLECTION_PROJECTION_DATA_ORM:
      return Object.assign({}, state, {
        getCollectionProjectionDataORM: payload
      });
    case GET_ACTION_FOR_COLLECTION_PROJECTION:
      return Object.assign({}, state, {
        getActionForCollectionProjection: payload
      });

    case GET_COLLECTION_PROJECTION_SUMMARY_ORM:
      return Object.assign({}, state, {
        getCollectionProjectionSummaryOrm: payload
      });

    case GET_COLLECTION_PROJECTION_ORM:
      return Object.assign({}, state, {
        getCollectionProjectionOrm: payload
      });

    case GET_COLLECTION_PROJECTION_ORM_EXPORT:
      return Object.assign({}, state, {
        getCollectionProjectionOrmExport: payload
      });

    case GET_QC_ORM:
      return Object.assign({}, state, {
        getQcORM: payload
      });

    case GET_QC_ORM_EXPORT:
      return Object.assign({}, state, {
        getQcORMExport: payload
      });

    case GET_ACTION_FOR_QC:
      return Object.assign({}, state, {
        getActionForQc: payload
      });

    case GET_QC_DATA_ORM:
      return Object.assign({}, state, { getQcDataORM: payload });
    case GET_QC_SUMMARY_ORM:
      return Object.assign({}, state, { getQcSummaryORM: payload });

    case GET_QC_INSPECTION_DATA_ORM:
      return Object.assign({}, state, {
        getQcInspectionDataOrm: payload
      });
    case GET_QC_OBSERVATION_DATA_ORM:
      return Object.assign({}, state, { getQcObservationDataOrm: payload });
    case GET_QC_TRAINING_DATA_ORM:
      return Object.assign({}, state, { getQcTrainingDataOrm: payload });
    case GET_QC_WALKTHROUGH_DATA_ORM:
      return Object.assign({}, state, { getQcWalkthroughDataORM: payload });

    case GET_QC_INSPECTION_ORM:
      return Object.assign({}, state, {
        getQcInspectionORM: payload
      });
    case GET_QC_OBSERVATION_ORM:
      return Object.assign({}, state, { getQcObservationORM: payload });
    case GET_QC_TRAINING_ORM:
      return Object.assign({}, state, { getQcTrainingORM: payload });
    case GET_QC_WALKTHROUGH_ORM:
      return Object.assign({}, state, { getQcWalkthroughORM: payload });
    case GET_ACCOUNT_INVOICE_DATA:
      return Object.assign({}, state, { getAccountInvoiceData: payload });
    case GET_ACCOUNT_INVOICE_SUMMARY:
      return Object.assign({}, state, { getAccountInvoiceSummary: payload });
    case GET_ACCOUNT_INVOICE:
      return Object.assign({}, state, { getAccountInvoice: payload });

    case GET_ACCOUNT_MARKETING_DATA:
      return Object.assign({}, state, { getAccountMarketingData: payload });
    case GET_ACCOUNT_MARKETING_SUMMARY:
      return Object.assign({}, state, { getAccountMarketingSummary: payload });
    case GET_ACCOUNT_MARKETING:
      return Object.assign({}, state, { getAccountMarketing: payload });
    //CRM User Dashboard
    case GET_CRM_PAYMENT_OUTSTANDING_DATA:
      return Object.assign({}, state, {
        getCRMPaymentOutStandingData: payload
      });
    default:
      return state;
  }
};

export default Dashboard_reducer;
